import { API } from '@/constant/constants'
import { MARKER } from '@/types'
import axiosClient from '../axiosClient'

export const markerApi = {
  getAll() {
    const url = API.OPERATIONS.MARKER.DEFAULT
    return axiosClient.get<MARKER[]>(url)
  },
}

export default markerApi
